import { render, staticRenderFns } from "./OrderCorrection.vue?vue&type=template&id=3f236cf1&scoped=true&"
import script from "./OrderCorrection.vue?vue&type=script&lang=js&"
export * from "./OrderCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f236cf1",
  null
  
)

export default component.exports